(function () {
  'use strict';
  var root = document.getElementById('vtx-xm');
  if (!root || root.__vtxPt) return;
  root.__vtxPt = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var i18n = {};
  try { i18n = JSON.parse(document.getElementById('vtx-xm-i18n').textContent); } catch (e) {}
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var sectionId = root.dataset.sectionId;

  var st = { page: 1, pages: 1, pending: {}, soldout: [], prefetching: null, instock: false, price: null, types: [], typeCounts: null, tiers: null, busy: false };

  /* ---------- helpers ---------- */
  function curParams() { return new URL(location.href).searchParams; }
  function carry(u) {
    var cur = curParams();
    ['view', 'preview_theme_id'].forEach(function (k) { if (cur.has(k) && !u.searchParams.has(k)) u.searchParams.set(k, cur.get(k)); });
    return u;
  }
  function sectionUrl(href, page) {
    var u = carry(new URL(href, location.origin));
    u.searchParams.set('section_id', sectionId);
    if (page && page > 1) u.searchParams.set('page', page); else u.searchParams.delete('page');
    return u.toString();
  }
  function pageUrl(href) {
    var u = carry(new URL(href, location.origin));
    u.searchParams.delete('page'); u.searchParams.delete('section_id');
    return u;
  }
  function fetchDoc(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) { return new DOMParser().parseFromString(h, 'text/html'); });
  }
  function grid() { return $('#vtx-xm-grid'); }
  function results() { return $('#vtx-xm-results'); }
  function items() { var g = grid(); return g ? $$(':scope > li.vtx-xm-item', g) : []; }
  function nextPage() { return st.page + 1; }
  function done() { return nextPage() > st.pages; }
  function fmt(tpl, map) { return tpl.replace(/__([A-Z])__/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function money(n) {
    try { return new Intl.NumberFormat(document.documentElement.lang || i18n.locale || undefined, { style: 'currency', currency: i18n.currency, maximumFractionDigits: 0 }).format(n); }
    catch (e) { return String(Math.round(n)); }
  }
  function say(t) { var s = $('[data-vtx-status]'); if (s) s.textContent = t || ''; }

  /* ---------- sticky offset below the theme header ---------- */
  var hdr = $('.section-header') || $('header.header');
  function setTop() {
    var top = 0;
    if (hdr) {
      var sticky = hdr.classList.contains('shopify-section-header-sticky') || getComputedStyle(hdr).position === 'sticky';
      var hidden = hdr.classList.contains('shopify-section-header-hidden');
      top = sticky && !hidden ? hdr.offsetHeight : 0;
    }
    root.style.setProperty('--vtx-xm-top', top + 'px');
  }
  setTop();
  if (hdr && window.MutationObserver) new MutationObserver(setTop).observe(hdr, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', setTop, { passive: true });

  /* ---------- hero count-up (skipped for reduced motion) ---------- */
  (function () {
    var el = $('[data-vtx-count]');
    if (!el || reduce || !('IntersectionObserver' in window)) return;
    var n = parseInt(el.dataset.vtxCount, 10); if (!n) return;
    var started = false;
    var io = new IntersectionObserver(function (es) {
      if (started || !es[0].isIntersecting) return; started = true; io.disconnect();
      var t0 = null;
      function step(ts) { if (t0 === null) t0 = ts; var p = Math.min(1, (ts - t0) / 900); el.textContent = Math.round(n * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); else el.textContent = n; }
      el.textContent = '0'; requestAnimationFrame(step);
    });
    io.observe(el);
  })();

  /* ---------- dropdowns ---------- */
  function closeDD(except) { $$('.vtx-xm-dd[open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); }); }
  root.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.classList && d.classList.contains('vtx-xm-dd') && d.open) { closeDD(d); if (d.dataset.vtxDd === 'price') ensureTiers(); }
  }, true);
  document.addEventListener('click', function (e) { if (!e.target.closest('.vtx-xm-dd')) closeDD(); else if (e.target.classList && e.target.classList.contains('vtx-xm-dd')) e.target.removeAttribute('open'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDD(); });

  /* ---------- pause hero animations while the hero is off screen ---------- */
  (function () {
    var h = $('.vtx-xm-hero'); if (!h || reduce || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) { root.classList.toggle('is-off', !es[0].isIntersecting); }).observe(h);
  })();

  /* polite live region for "added to cart" etc. */
  var live = document.createElement('p'); live.className = 'visually-hidden'; live.setAttribute('role', 'status'); root.appendChild(live);

  /* ---------- results state ---------- */
  function initResults() {
    var r = results(); if (!r) return;
    st.pages = parseInt(r.dataset.pages || '1', 10);
    st.page = 1; st.pending = {}; st.prefetching = null; st.inflight = null;
    st.soldout = items().filter(function (li) { return li.dataset.available === 'false'; });
    if (done()) finalize();
    applyClient(); updateCount();
    var btn = $('#vtx-xm-more-btn'); if (btn) btn.hidden = done();
    scheduleIdlePrefetch();
  }

  function finalize() {
    var g = grid(); if (!g) return;
    var sold = st.soldout; st.soldout = [];
    sold.forEach(function (li) { li.hidden = false; });
    /* [data-vtx-start] first, then in-stock by data-rank-score desc (stable), sold-out last */
    var start = $$(':scope > [data-vtx-start]', g);
    var stock = items().filter(function (li) { return start.indexOf(li) < 0 && sold.indexOf(li) < 0; });
    var keyed = stock.map(function (li, i) { return { li: li, i: i, s: parseFloat(li.dataset.rankScore) || 0 }; });
    keyed.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    var frag = document.createDocumentFragment();
    start.forEach(function (li) { frag.appendChild(li); });
    keyed.forEach(function (k) { frag.appendChild(k.li); });
    sold.forEach(function (li) { frag.appendChild(li); });
    g.appendChild(frag);
  }

  function fetchPage(p) {
    if (st.pending[p]) return st.pending[p];
    var href = location.pathname + location.search;
    st.pending[p] = fetchDoc(sectionUrl(href, p)).then(function (doc) {
      return $$('#vtx-xm-grid > li.vtx-xm-item', doc);
    }).catch(function () { delete st.pending[p]; return []; });
    return st.pending[p];
  }

  function prefetchAll() {
    if (st.prefetching) return st.prefetching;
    var ps = []; for (var p = nextPage(); p <= st.pages; p++) ps.push(fetchPage(p));
    st.prefetching = Promise.all(ps); return st.prefetching;
  }
  function scheduleIdlePrefetch() {
    if (st.pages < 2) { fillTypeCounts(); return; }
    var go = function () { prefetchAll().then(fillTypeCounts); };
    if ('requestIdleCallback' in window) requestIdleCallback(function () { setTimeout(go, 1200); }, { timeout: 5000 }); else setTimeout(go, 3500);
  }
  ['pointerover', 'touchstart', 'focusin'].forEach(function (ev) {
    $('#vtx-xm-bar').addEventListener(ev, function () { prefetchAll().then(fillTypeCounts); }, { once: true, passive: true });
    var tl = $('#vtx-xm-tiles'); if (tl) tl.addEventListener(ev, function () { prefetchAll().then(fillTypeCounts); }, { once: true, passive: true });
  });

  function appendItems(lis) {
    var g = grid(); var frag = document.createDocumentFragment(); var k = 0;
    lis.forEach(function (li) {
      var n = document.importNode(li, true);
      if (n.dataset.available === 'false') { n.hidden = true; st.soldout.push(n); }
      else { k++; n.style.setProperty('--i', Math.min(k, 12)); n.hidden = false; }
      frag.appendChild(n);
    });
    g.appendChild(frag);
  }

  function loadMore() {
    if (done()) return Promise.resolve();
    if (st.inflight) return st.inflight;
    var btn = $('#vtx-xm-more-btn'); if (btn) btn.disabled = true; say(i18n.loading);
    var p = nextPage();
    st.inflight = fetchPage(p).then(function (lis) {
      delete st.pending[p];
      appendItems(lis); st.page = p;
      if (done()) { finalize(); if (btn) btn.hidden = true; }
      applyClient(); updateCount();
    }).then(function () { st.inflight = null; if (btn) btn.disabled = false; say(''); }, function () { st.inflight = null; if (btn) btn.disabled = false; say(''); });
    return st.inflight;
  }

  function loadAll() {
    if (done()) return Promise.resolve();
    return loadMore().then(function () { return loadAll(); });
  }

  /* ---------- client-side filters: product type (OR inside the group), price, in stock (AND across groups) ---------- */
  function clientActive() { return st.instock || st.price !== null || st.types.length > 0; }
  function tagsOf(li) { return li.dataset.tags || ''; }
  function matchesTypes(li) {
    if (!st.types.length) return true;
    var t = tagsOf(li);
    for (var i = 0; i < st.types.length; i++) if (t.indexOf('|' + st.types[i] + '|') > -1) return true;
    return false;
  }
  function applyClient() {
    root.classList.toggle('is-instock', st.instock);
    var any = 0;
    items().forEach(function (li) {
      var ok = matchesTypes(li);
      if (ok && st.instock && li.dataset.available === 'false') ok = false;
      if (ok && st.price) { var pr = parseInt(li.dataset.price, 10) / 100; if (pr < st.price.min || pr >= st.price.max) ok = false; }
      if (ok) { delete li.dataset.vtxOut; any++; } else li.dataset.vtxOut = '1';
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-vtx-start]'), function (b) { b.hidden = clientActive(); });
    var empty = $('#vtx-xm-empty'); if (empty) empty.hidden = !(any === 0 && done());
    var more = $('#vtx-xm-more'); if (more) more.hidden = (any === 0 && done());
    syncUI(); renderChips(); writeUrl();
  }

  function typeLabel(tag) {
    var el = $('.vtx-xm-tile[data-vtx-type="' + tag.replace(/"/g, '\\"') + '"] .vtx-xm-tile__name') || $('.vtx-xm-opt[data-vtx-type="' + tag.replace(/"/g, '\\"') + '"] .vtx-xm-opt__l');
    return el ? el.textContent : tag;
  }
  function syncUI() {
    $$('[data-vtx-type]').forEach(function (b) {
      var on = st.types.indexOf(b.dataset.vtxType) > -1;
      b.classList.toggle('is-active', on);
      if (b.classList.contains('vtx-xm-tile')) b.setAttribute('aria-pressed', on ? 'true' : 'false'); else b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var all = $('[data-vtx-all-types]'); if (all) all.classList.toggle('is-active', st.types.length === 0 && false);
    var dd = $('[data-vtx-dd="type"]'), nb = $('[data-vtx-type-n]');
    if (dd) dd.classList.toggle('is-on', st.types.length > 0);
    if (nb) { nb.hidden = st.types.length === 0; nb.textContent = st.types.length; }
    var pd = $('[data-vtx-dd="price"]'); if (pd) pd.classList.toggle('is-on', !!st.price);
    var cb = $('#vtx-xm-instock'); if (cb) cb.checked = st.instock;
    syncPriceUI();
  }
  function renderChips() {
    var box = $('#vtx-xm-chips'); if (!box) return;
    box.innerHTML = '';
    if (!clientActive()) { box.hidden = true; return; }
    function chip(txt, fn, cls) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'vtx-xm-chip' + (cls ? ' ' + cls : '');
      var s = document.createElement('span'); s.textContent = txt; b.appendChild(s);
      if (!cls) { var x = document.createElement('b'); x.setAttribute('aria-hidden', 'true'); x.textContent = '×'; b.appendChild(x); }
      b.addEventListener('click', fn); box.appendChild(b);
    }
    st.types.slice().forEach(function (t) { chip(typeLabel(t), function () { toggleType(t); }); });
    if (st.price) chip(st.price.label, function () { setPrice(null); });
    if (st.instock) chip(i18n.inStock, function () { setInstock(false); });
    chip(i18n.clear, clearAll, 'vtx-xm-chip--clear');
    box.hidden = false;
  }
  function clearAll() { st.instock = false; st.price = null; st.types = []; applyClient(); updateCount(); }

  function needAll() {
    if (!clientActive() || done()) return Promise.resolve();
    say(i18n.loading);
    return loadAll().then(function () { say(''); applyClient(); updateCount(); });
  }
  function toggleType(tag) {
    var i = st.types.indexOf(tag);
    if (i > -1) st.types.splice(i, 1); else st.types.push(tag);
    applyClient(); updateCount(); needAll(); fillTypeCounts();
  }
  function setInstock(v) { st.instock = v; applyClient(); updateCount(); needAll(); }
  function setPrice(t) { st.price = t; applyClient(); updateCount(); closeDD(); needAll(); }

  /* type counts, from the cards of every page (read once, quietly) */
  function fillTypeCounts() {
    var apply = function () {
      if (!st.typeCounts) return;
      $$('[data-vtx-type]').forEach(function (b) {
        var n = st.typeCounts[b.dataset.vtxType] || 0; var t = b.querySelector('.vtx-xm-tile__n') || b.querySelector('em'); if (t) t.textContent = n ? n : '';
        if (!n && b.classList.contains('vtx-xm-opt')) b.hidden = true;
        if (!n && b.classList.contains('vtx-xm-tile')) { var tli = b.closest('li'); if (tli) tli.hidden = true; }
      });
    };
    if (st.typeCounts) { apply(); return; }
    prefetchAll().then(function () {
      return Promise.all(Object.keys(st.pending).map(function (k) { return st.pending[k]; }));
    }).then(function (arrs) {
      var all = items(); arrs.forEach(function (lis) { all = all.concat(lis); });
      var seen = {}, c = {}, n = 0;
      all.forEach(function (li) {
        var id = li.dataset.productId; if (seen[id]) return; seen[id] = 1; n++;
        tagsOf(li).split('|').forEach(function (t) { if (t) c[t] = (c[t] || 0) + 1; });
      });
      if (n >= parseInt(results().dataset.total || '0', 10)) { st.typeCounts = c; apply(); }
    });
  }

  /* ---------- URL state: ?type=stems,cooling&instock=1&price=0-15 (kept next to view / preview_theme_id / sort_by) ---------- */
  var slugs = {};
  $$('.vtx-xm-tile[data-slug]').forEach(function (b) { slugs[b.dataset.slug] = b.dataset.vtxType; });
  $$('.vtx-xm-opt[data-slug]').forEach(function (b) { slugs[b.dataset.slug] = b.dataset.vtxType; });
  function tagToSlug(tag) { for (var k in slugs) if (slugs[k] === tag) return k; return null; }
  function writeUrl() {
    if (!st.urlReady) return;
    var u = new URL(location.href), p = u.searchParams;
    var sl = st.types.map(tagToSlug).filter(Boolean);
    if (sl.length) p.set('type', sl.join(',')); else p.delete('type');
    if (st.instock) p.set('instock', '1'); else p.delete('instock');
    if (st.price) p.set('price', st.price.min + '-' + (st.price.max >= 1e9 ? '' : st.price.max)); else p.delete('price');
    var next = u.pathname + (p.toString() ? '?' + p.toString() : '');
    if (next !== location.pathname + location.search) history.replaceState(history.state, '', next);
  }
  function readUrl() {
    var p = curParams();
    st.types = (p.get('type') || '').split(',').map(function (s) { return slugs[s]; }).filter(Boolean);
    st.instock = p.get('instock') === '1';
    st.price = null;
    var pr = p.get('price');
    if (pr && /^\d+(\.\d+)?-(\d+(\.\d+)?)?$/.test(pr)) {
      var a = pr.split('-'); var mn = parseFloat(a[0]), mx = a[1] === '' ? 1e9 : parseFloat(a[1]);
      var panel = $('#vtx-xm-pricepanel');
      var label = mn === 0 ? fmt(panel.dataset.under, { P: money(mx) }) : mx >= 1e9 ? fmt(panel.dataset.over, { P: money(mn) }) : fmt(panel.dataset.mid, { F: money(mn), T: money(mx) });
      st.price = { min: mn, max: mx, label: label };
    }
  }

  /* price tiers are built from the real prices of every product on the page (all pages are read once, quietly) */
  function allPrices() {
    var list = items().map(function (li) { return parseInt(li.dataset.price, 10) / 100; });
    var extra = [];
    return Promise.all(Object.keys(st.pending).map(function (k) { return st.pending[k]; })).then(function (arrs) {
      arrs.forEach(function (lis) { lis.forEach(function (li) { extra.push(parseInt(li.dataset.price, 10) / 100); }); });
      return list.concat(extra).filter(function (n) { return n > 0; }).sort(function (a, b) { return a - b; });
    });
  }
  function nice(x) { var step = x < 30 ? 5 : x < 100 ? 10 : x < 300 ? 25 : x < 1000 ? 50 : 100; return Math.max(step, Math.round(x / step) * step); }
  function ensureTiers() {
    if (st.tiers) return;
    var panel = $('#vtx-xm-pricepanel'); if (!panel || panel.dataset.busy) return;
    panel.dataset.busy = '1';
    prefetchAll().then(allPrices).then(function (ps) {
      if (ps.length < 4) return;
      var t1 = nice(ps[Math.floor(ps.length * 0.34)]), t2 = nice(ps[Math.floor(ps.length * 0.67)]);
      if (t2 <= t1) t2 = t1 + (t1 < 30 ? 5 : 10);
      st.tiers = [
        { min: 0, max: t1, label: fmt(panel.dataset.under, { P: money(t1) }) },
        { min: t1, max: t2, label: fmt(panel.dataset.mid, { F: money(t1), T: money(t2) }) },
        { min: t2, max: 1e9, label: fmt(panel.dataset.over, { P: money(t2) }) }
      ];
      st.tiers.forEach(function (t, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'vtx-xm-opt'; b.dataset.vtxPrice = String(i); b.textContent = t.label; panel.appendChild(b);
      });
      syncPriceUI();
    });
  }
  function syncPriceUI() {
    var panel = $('#vtx-xm-pricepanel'); if (!panel) return;
    $$('[data-vtx-price]', panel).forEach(function (b) {
      var k = b.dataset.vtxPrice, on;
      if (k === 'any') on = st.price === null; else { var t = st.tiers && st.tiers[+k]; on = !!(st.price && t && t.min === st.price.min && t.max === st.price.max); }
      b.classList.toggle('is-active', on);
    });
    var lab = $('[data-vtx-price-label]'); if (lab) lab.textContent = st.price ? st.price.label : lab.dataset.base || lab.textContent;
  }
  (function () { var lab = $('[data-vtx-price-label]'); if (lab) lab.dataset.base = lab.textContent; })();

  /* ---------- count text ---------- */
  function updateCount() {
    var el = $('#vtx-xm-count'), r = results(); if (!el || !r) return;
    var total = parseInt(r.dataset.total || '0', 10);
    var vis = items().filter(function (li) { return !li.hidden && !li.dataset.vtxOut; }).length;
    var tplR = el.dataset.tplResults, tplS = el.dataset.tplShowing;
    if (clientActive() && done()) el.textContent = fmt(tplR, { N: vis });
    else if (!done()) el.textContent = fmt(tplS, { S: vis, T: total });
    else el.textContent = fmt(tplR, { N: total });
  }

  /* ---------- sort = Shopify's own sort (re-reads the results block; filters stay applied) ---------- */
  function swapTo(href, push) {
    var url = pageUrl(href);
    var rs = results(); if (rs) rs.classList.add('is-loading');
    fetchDoc(sectionUrl(url.toString())).then(function (doc) {
      var a = $('#vtx-xm-results'), b = $('#vtx-xm-results', doc);
      if (a && b) { a.innerHTML = b.innerHTML; ['total', 'pages', 'page'].forEach(function (k) { a.dataset[k] = b.dataset[k]; }); }
      if (push) history.pushState({ vtxAz: 1 }, '', url.pathname + url.search);
      if (rs) rs.classList.remove('is-loading');
      initResults(); needAll();
    }).catch(function () { if (rs) rs.classList.remove('is-loading'); location.href = href; });
  }

  root.addEventListener('click', function (e) {
    var ty = e.target.closest('[data-vtx-type]');
    if (ty) { e.preventDefault(); toggleType(ty.dataset.vtxType); return; }
    if (e.target.closest('[data-vtx-all-types]')) { e.preventDefault(); st.types = []; applyClient(); updateCount(); return; }
    if (e.target.closest('[data-vtx-clear]')) { e.preventDefault(); clearAll(); return; }
    var pb = e.target.closest('[data-vtx-price]');
    if (pb) { e.preventDefault(); var k = pb.dataset.vtxPrice; if (k === 'any') setPrice(null); else if (st.tiers) setPrice(st.tiers[+k]); return; }
    var j = e.target.closest('[data-vtx-jump]');
    if (j) { var t = $('#vtx-xm-start'); if (t) { e.preventDefault(); if (st.types.length || st.instock || st.price) clearAll(); setTimeout(function () { t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }, 30); } return; }
    var add = e.target.closest('[data-vtx-add]');
    if (add) { e.preventDefault(); addItems([{ id: parseInt(add.dataset.variantId, 10), quantity: 1 }], add); return; }
    var pk = e.target.closest('[data-vtx-pack-add]');
    if (pk) { e.preventDefault(); var its = []; try { its = JSON.parse(pk.dataset.items); } catch (er) {} addItems(its, pk); return; }
    if (e.target.closest('#vtx-xm-more-btn')) { loadMore(); }
  });

  /* second product photo is only downloaded when someone points at a card */
  root.addEventListener('pointerover', function (e) {
    var m = e.target.closest && e.target.closest('.vtx-xm-card__media'); if (!m) return;
    var i2 = m.querySelector('img[data-src]'); if (i2) { i2.addEventListener('load', function () { m.classList.add('vtx-h2-ready'); }, { once: true }); i2.src = i2.dataset.src; i2.removeAttribute('data-src'); }
  }, { passive: true });

  $('#vtx-xm-sort').addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', this.value); u.searchParams.delete('page');
    swapTo(u.pathname + u.search, true);
  });
  $('#vtx-xm-instock').addEventListener('change', function () { setInstock(this.checked); });
  window.addEventListener('popstate', function () { readUrl(); swapTo(location.pathname + location.search, false); });

  /* ---------- add to cart (single item or whole pack) ---------- */
  function addItems(its, btn) {
    if (!its.length) return;
    var round = btn.classList.contains('vtx-xm-add--round');
    var old = btn.textContent; btn.disabled = true;
    var body = { items: its, sections: 'cart-drawer,cart-notification-product,cart-notification-button,cart-icon-bubble', sections_url: location.pathname };
    fetch((i18n.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        if (!round) btn.textContent = '✓ ' + i18n.added;
        btn.classList.add('is-done'); live.textContent = i18n.added;
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var first = (j.items && j.items[0]) || {};
        var payload = Object.assign({ key: first.key, id: first.id }, j);
        var drawn = false;
        if (cart && cart.renderContents && j.sections) { try { cart.renderContents(payload); drawn = true; } catch (e) {} }
        if (!drawn && j.sections && j.sections['cart-icon-bubble']) { var b = document.getElementById('cart-icon-bubble'); if (b) { var d = new DOMParser().parseFromString(j.sections['cart-icon-bubble'], 'text/html'); var n = d.getElementById('cart-icon-bubble') || d.body.firstElementChild; if (n) b.innerHTML = n.innerHTML; } }
        if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'vtx-xm', cartData: j }); } catch (e) {} }
        setTimeout(function () { if (!round) btn.textContent = old; btn.classList.remove('is-done'); btn.disabled = false; }, 1800);
      })
      .catch(function () { live.textContent = i18n.error; if (!round) btn.textContent = i18n.error; else btn.classList.add('is-err'); setTimeout(function () { if (!round) btn.textContent = old; btn.classList.remove('is-err'); btn.disabled = false; }, 2500); });
  }

  /* ---------- go ---------- */
  readUrl();
  var hadUrlFilters = clientActive();
  if (hadUrlFilters) root.classList.add('is-filtering');
  initResults();
  st.urlReady = true;
  if (hadUrlFilters) needAll().then(function () { root.classList.remove('is-filtering'); fillTypeCounts(); });
  writeUrl();
})();
